<template>
  <div id="app" :class="[safeModeEnabled ? 'safe-mode' : '', nightModeEnabled ? 'night-mode' : '', 'ui-dynamic-colors']">
    <header class="main-navigation ui-dynamic-colors">
      <nav class="primary-menu">
        <router-link to="/" class="main-logo">
          <img class="logo" src="./assets/logo-sm.png" alt="Prawn" />
        </router-link>
        <router-link to="/scenes" class="ui-dynamic-colors">
          Scenes
        </router-link>
        <router-link to="/models" class="ui-dynamic-colors">
          Models
        </router-link>
        <router-link to="/studios" class="ui-dynamic-colors">
          Studios
        </router-link>		
        <router-link to="/tags" class="ui-dynamic-colors">
          Tags
        </router-link>
        <router-link to="/collections" class="ui-dynamic-colors">
          Collections
        </router-link>	
        <router-link to="/galleries" class="ui-dynamic-colors">
          Galleries
        </router-link>	
      </nav>
      <div class="secondary-menu">
        <div class="toggle night-mode">
          <input type="checkbox" id="night-mode__toggle"
          @click="toggleNightMode"
          :class="[nightModeEnabled ? '' : 'active']" /><label for="night-mode__toggle">Night Mode</label>
        </div>
        <div class="toggle safe-mode">
          <input type="checkbox" id="safe-mode__toggle"
          @click="toggleSafeMode"
          :class="[safeModeEnabled ? 'active' : '']" /><label for="safe-mode__toggle">Safe Mode</label>
        </div>
      </div>
    </header>
    <router-view />
    <footer>
      <img class="logo" src="./assets/logo.png"/>
    </footer>
  </div>
</template>

<script>


export default {
  name: "app",
  data() {
    return {
      safeModeEnabled: localStorage.getItem('safeMode'),
      nightModeEnabled: localStorage.getItem('nightMode')
    };
  },
  methods: {
    toggleSafeMode() {
      this.safeModeEnabled = !this.safeModeEnabled;
      if (this.safeModeEnabled) {
        document.querySelector('#app').classList.add('safe-mode');
      } else {
        document.querySelector('#app').classList.remove('safe-mode');
      }
      localStorage.setItem('safeMode', this.safeModeEnabled)
    },
    toggleNightMode() {
      this.nightModeEnabled = !this.nightModeEnabled;
      if (this.nightModeEnabled) {
        document.querySelector('#app').classList.add('night-mode');
      } else {
        document.querySelector('#app').classList.remove('night-mode');
      }
      localStorage.setItem('nightMode', this.nightModeEnabled)
    },
  },
};
</script>


<style>
* { box-sizing: border-box; }
body {
  background-color: var(--color-mono-6);
}
#app {
  margin: 0;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-mono-0);
  padding: 3.5rem 0 0;
  background-color: var(--color-mono-6);
}

#app > header {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0;
  left: 0;
  width: 100%;
  background-color: var(--color-mono-1);
  font-size: 1rem;
  height: 3.5rem;
  z-index: 99;
  padding: 0 36px 0 24px;
}

footer {
  padding: 5rem 1rem;
  text-align: center;
  font-size: 1rem;
}

footer img {
  display: inline-block;
  height: 8em;
  width: auto;
}
.main-logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-logo:hover img {
  transform: scale(1.1);
}
.main-logo img {
  width: 24px;
  transition: transform 0.35s ease-in-out;
}
nav {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

nav a {
  color: var(--color-mono-6);
  text-decoration: none;
  text-align: center;
  padding: 0 1rem;
  font-weight: 700;
}
.secondary-menu {
  display: flex;
  
}
</style>

<style>
/* Global styles */

body {
  margin: 0;
  padding: 0;
}

.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.list {
  display: grid;
  margin: 0;
  padding: 0;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
}

.list > li {
  display: block;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: stretch;
}

.list a {
  text-decoration: none;
  display: block;
  flex-grow: 1;
  color: var(--color-mono-4);
}

.list h3 {
  margin: 0;
  padding: 0;
  line-height: 1em;
}

.list img {
  display: block;
  height: auto;
  width: 100%;
  margin-right: 0.5rem;
}

.scene-list {
  display: grid;
  margin: 0;
  padding: 36px;
  grid-gap: 36px;
  grid-template-columns: 1fr;
}
@media (min-width: 600px) {
  .scene-list {
    grid-template-columns: 1fr 1fr;
  }
}
@media (min-width: 1000px) {
  .scene-list {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
.scene-list li {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* model related stuff */
.scenes__model-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: var(--color-mono-0);
  text-decoration: none;
}
.scenes__model-link {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-mono-0);
  text-decoration: none;
  display: flex;
  height: 100%;
}
li.model > a {
  overflow: hidden;
}
.model__headshot {
  position: relative;
  display: block;
  padding-bottom: 125%;
  background-position: center top;
  background-size: cover;
  background-color: var(--color-mono-5);
  background-repeat: no-repeat;
	width: 100%;
  border-radius: 5px;
  overflow: hidden;
  transition: transform 1s ease-in-out, box-shadow 1s ease-in-out;
  background-size: cover;
  background-position: center;
  box-shadow: inset 3px 5px 5px rgba(0, 0, 0, 0.5);
  transform: scale3D(1,1,1);
}
.model__headshot:hover {
  transform: scale3D(1.25,1.25,1);
  box-shadow: inset 1px 0 0 rgba(0, 0, 0, 0.125);
  transition: transform 10s ease-in-out, box-shadow 10s ease-in-out;
}

/*************************************************************/
/* UI    
/*************************************************************/



:root {

  --color-mono-0: rgb(0,0,0);
  --color-mono-1: rgb(60,60,60);
  --color-mono-2: rgb(120,120,120);
  --color-mono-3: rgb(180,180,180);
  --color-mono-4: rgb(200,200,200);
  --color-mono-5: rgb(230,230,230);
  --color-mono-6: rgb(255,255,255);

  --ui-primary-active: rgba(71, 231, 76, 1);
  --ui-secondary-active: rgba(90, 178, 255, 1);

  --ui-primary-error: rgba(231, 81, 71, 0.75);
}
.night-mode {
  --color-mono-0: rgb(180,180,180);
  --color-mono-1: rgb(160,160,160);
  --color-mono-2: rgb(120,120,120);
  --color-mono-3: rgb(80,80,80);
  --color-mono-4: rgb(40,40,40);
  --color-mono-5: rgb(20,20,20);
  --color-mono-6: rgb(0,0,0);

  --ui-primary-active: rgba(71, 231, 166, 0.75);
  --ui-primary-error: rgba(231, 81, 71, 0.75);
  
  --ui-secondary-active: rgba(71, 99, 231, 0.75);
}
* {
  box-sizing: border-box;
}
*:focus-visible {
    border: 1px solid var(--ui-primary-active);
    border-radius: 96px;
    outline: none;
}

#app > .main-navigation {
  background-color: var(--color-mono-5);
  overflow: scroll;
}

.ui-dynamic-colors {
  transition: background-color 0.75s ease-in-out, color 0.75s ease-in-out;
}

.main-navigation a {
  color: var(--color-mono-0);
}

.button {
  font-size: 1rem;
  color: var(--color-mono-0);
  font-weight: 500;
  border-width: 1px;
  border-style: solid;
  padding: 4px 12px;
  margin-right: 12px;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out;
}
.button:hover {
  background-color: var(--color-mono-0);
  color: var(--color-mono-6);
}
.edit-button {
  font-size: 1rem;
  color: var(--color-mono-0);
  font-weight: 500;
  border-width: 1px;
  border-style: solid;
  padding: 4px 12px;
  margin-right: 12px;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out;
}
.edit-button:hover {
  background-color: var(--color-mono-0);
  color: var(--color-mono-6);
}
.button__safe-mode {
  appearance: none;
  justify-self: flex-end;
  background-color: var(--color-mono-0);
  color: var(--color-mono-6);
  font-size: 0.875rem;
  border-color: #10e204;
  background-color: var(--color-mono-6)fff;
  color: var(--color-mono-0);
}
.edit-button:hover {
  background-color: var(--color-mono-0);
  color: var(--color-mono-6);
}
.button__safe-mode:before {
  content: 'Enable ';
}
.button__safe-mode.active {
  border-color: #e20404;
}
.button__safe-mode.active:before {
  content: 'Disable ';
}
.scene-tile__preview-container, .image-container, .safe-image {
  display: block;
  position: relative;
  overflow: hidden;
  padding-bottom: 0;
  width: 100%;
  height: auto;
  border-radius: 5px;
  font-size: 0;
}
.scene-tile__preview-container:after, .image-container:after, .safe-image:after {
  content: '';
  background-color: var(--color-mono-5);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 2;
  transition: opacity 0.125s ease-in-out 0s;
  opacity: 0;
}
.safe-mode .scene-tile__model-image { 
  background-image: none !important;
}
.safe-mode .scene-tile__preview-container:after, .safe-mode .image-container:after, .safe-mode .safe-image:after {
  opacity: 0.975 !important;
}
.safe-mode .scene-tile__preview-container:hover:after, .safe-mode .image-container:hover:after, .safe-mode .safe-image:hover:after {
  opacity: 0 !important;
  transition: opacity 0.25s ease-in-out 3s;
}
.toggle {
  position: relative;
  margin-left: 16px;
}
.toggle.night-mode label {
	background: var(--ui-secondary-active);
}
.toggle:before {
    box-sizing: border-box;
    content: 'SAFE';
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    top: 1px;
    left: 0;
    width: 100%;
    height: 100%;
    color: rgb(0 0 0);
    transition: all 0.3s;
    font-size: 8px;
    font-weight: 600;
    z-index: 9;
    padding: 0 7px;
    letter-spacing: 0.3px;
    pointer-events: none;
    opacity: 0;
}
.toggle input[type=checkbox]{
	height: 0;
	width: 0;
	visibility: hidden;
  position: absolute;
}
.toggle label {
	cursor: pointer;
	text-indent: -9999px;
  width: 56px;
  height: 26px;
	background: var(--ui-primary-active);
	display: block;
	border-radius: 48px;
	position: relative;
  transition: all 0.3s;
}
.toggle label:after {
	content: '';
	position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  background: var(--color-mono-6);
  border-radius: 24px;
	transition: all 0.3s;
  box-shadow: 1px 1px 5px rgb(0 0 0 / 50%);
}
.toggle input:checked + label {
	background: #5b5b5b;
}
.toggle input:checked + label:after {
	left: calc(100% - 3px);
	transform: translateX(-100%);
}
.toggle label:active:after {
	width: 50px;
}

/*************************************************************/
/* Keyframe Animations     
/*************************************************************/

@keyframes favorite {
	0% {
		transform: scale(10%) translate(-50%,-50%);
    opacity: 1;
	}
	100% {
		transform: scale(125%) translate(-50%,-50%);
    opacity: 0;
	}
}
@keyframes screens {
	0% {
		transform: translateX(-0%);
	}

	4.16667% {
		transform: translateX(-4.16667%);
	}

	8.33333% {
		transform: translateX(-8.33333%);
	}

	12.5% {
		transform: translateX(-12.5%);
	}

	16.66667% {
		transform: translateX(-16.66667%);
	}

	20.83333% {
		transform: translateX(-20.83333%);
	}

	25.0% {
		transform: translateX(-25.0%);
	}

	29.16667% {
		transform: translateX(-29.16667%);
	}

	33.33333% {
		transform: translateX(-33.33333%);
	}

	37.5% {
		transform: translateX(-37.5%);
	}

	41.66667% {
		transform: translateX(-41.66667%);
	}

	45.83333% {
		transform: translateX(-45.83333%);
	}

	50.0% {
		transform: translateX(-50.0%);
	}

	54.16667% {
		transform: translateX(-54.16667%);
	}

	58.33333% {
		transform: translateX(-58.33333%);
	}

	62.5% {
		transform: translateX(-62.5%);
	}

	66.66667% {
		transform: translateX(-66.66667%);
	}

	70.83333% {
		transform: translateX(-70.83333%);
	}

	75.0% {
		transform: translateX(-75.0%);
	}

	79.16667% {
		transform: translateX(-79.16667%);
	}

	83.33333% {
		transform: translateX(-83.33333%);
	}

	87.5% {
		transform: translateX(-87.5%);
	}

	91.66667% {
		transform: translateX(-91.66667%);
	}

	95.83333% {
		transform: translateX(-95.83333%);
	}

	100.0% {
		transform: translateX(-100.0%);
	}
}
</style>


